<template>
  <EditorButton :title="$t('image')">
    <template v-slot:trigger="{ hide, show }">
      <MPopover
        ref="popover"
        placement="bottomRight"
        :overlay-style="{ width: '300px' }"
        @show="handleShowPopover"
      >
        <template v-slot:trigger>
          <MButton
            variant="transparent"
            class="text-neutral-darker"
            size="small"
            :shadow="false"
            @mouseenter="show"
            @mouseleave="hide"
          >
            <slot />
          </MButton>
        </template>
        <FlotoForm @submit="handleFormSubmit">
          <FlotoFormItem rules="required" :label="$t('image')">
            <FlotoAttachment
              v-model="image"
              as-link
              :use-public-api="usePublicApi"
              ignore-preference-validation
              :max-files="1"
              :button-text="`${$t('select')} ${$t('image')}`"
              :allowed-extensions="['png', 'jpg', 'jpeg']"
            />
          </FlotoFormItem>
          <template v-slot:submit>
            <div class="flex justify-end">
              <MButton type="submit" size="small" class="mx-1">
                {{ $t('add') }}
              </MButton>
              <MButton size="small" variant="default" @click="hideMenu">
                {{ $t('cancel') }}
              </MButton>
            </div>
          </template>
        </FlotoForm>
      </MPopover>
    </template>
  </EditorButton>
</template>

<script>
import { buildImageUrlFromRefFileName } from '@data/attachment'
import EditorButton from './editor-button'
export default {
  name: 'LinkButton',
  components: { EditorButton },
  props: {
    usePublicApi: { type: Boolean, default: false },
  },
  data() {
    return {
      image: [],
    }
  },
  methods: {
    handleShowPopover() {
      this.image = []
    },
    handleFormSubmit() {
      this.$emit('add', buildImageUrlFromRefFileName(this.image[0].refFileName))
      this.hideMenu()
    },
    hideMenu() {
      this.$emit('hide')
      this.$refs.popover.hide()
    },
  },
}
</script>
